import { useTheme } from '@emotion/react';
import { Button, Dialog, DialogActions, Stack, Typography } from '@mui/material';
import React from 'react';
import { useRef } from 'react';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import FormTextField from '../../../../components/FormTextField';
import { dialogButtonCancel, dialogButtonStyle } from '../../../../utils/commonStyle';
import { showmessage } from '../../../../utils/toastr';
import { useDispatch, useSelector } from 'react-redux';
import appapi from '../../../../api/apiClient';
import { setLoading } from '../../../../redux/features/appSlice';
import ErrorIcon from '@mui/icons-material/Error';

const validationSchema = yup.object({
  blockReason: yup.string('Block Reason').max(500, 'Block Reason must be at most 500 characters').min(3, 'Block Reason must be at least 3 characters').nullable(),
});

export default function ChangeStatusDialog({ modelOpen, handleClose, details }) {
  const theme = useTheme();
  const blackMain = theme.palette.deActivate.main;
  const formRef = useRef();
  const dispatch = useDispatch();

  const { user, userId } = useSelector((state) => state.auth);

  const sx = {
    '& .MuiDialog-container': {
      alignItems: 'center',
    },
    '& .MuiPaper-root': {
      width: '500px',
      minHeight: '224px',
      padding: '24px 16px 16px 16px',
      borderRadius: '4px',
    },
  };

  const handleBlock = async (values) => {
    dispatch(setLoading(true));
    const response = await appapi.put(`trader/block/${details?._id}`, { ...values });
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        showmessage(data?.message);
        handleClose(true);
        // refersh();
        // setConfirmVal('');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleUnBlock = async (values) => {
    dispatch(setLoading(true));
    const response = await appapi.put(`trader/unBlock/${details?._id}`, { ...values });
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        showmessage(data.message);
        handleClose(true);
        // refersh();
        // setConfirmVal('');
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      // onClose={handleClose}
      // TransitionComponent={Transition}
      className="AddUserContainer"
    >
      <Stack
        style={{ margin: '15px' }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div
          className="flex"
          style={{ alignItems: 'center', marginLeft: '10px' }}
        >
          <ErrorIcon sx={{ color: theme.palette.primary.dark, fontSize: '18px', marginRight: '10px' }} />
          <Typography
            style={{ color: theme.palette.primary.dark }}
            className="fw-bold fs-16 ff-Roboto"
          >
            Alert
          </Typography>
        </div>
      </Stack>
      <Stack
        style={{ backgroundColor: theme.palette.border.main, height: '1px', marginBottom: '15px', opacity: 0.5 }}
        className="mx-[25px]"
      />
      <Typography
        style={{ color: blackMain, marginLeft: '25px', marginBottom: '10px' }}
        className="fw-medium fs-18 ff-Roboto"
      >
        Are you sure you want to change the status to {details?.status === '1' ? 'Inactive' : 'Active'} ?
      </Typography>
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        initialValues={{
          blockReason: '',
          adminId: userId,
          adminName: 'test',
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          if (details?.status === '1') {
            handleBlock(values);
          } else {
            handleUnBlock(values);
          }
        }}
      >
        {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty }) => (
          <Form autoComplete="off">
            <Stack className="editContainer addContainer !m-[10px]">
              <Stack style={{ padding: '8px', margin: '10px', position: 'relative' }}>
                <Stack
                  className="flex"
                  direction="column"
                  justifyContent="space-between"
                  style={{ rowGap: 'initial' }}
                >
                  <Stack style={{ width: '420px' }}>
                    <FormTextField
                      name="blockReason"
                      multiline={true}
                      maxRows={3}
                      requiredMark={true}
                      label="Reason"
                      labelRight="(Max 500 Characters)"
                      inputProps={{ maxLength: 500 }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          minHeight: '100px !important',
                          display: 'block',
                        },
                      }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Stack>

            <DialogActions
              style={{
                height: '66px',
                justifyContent: 'center',
                paddingBottom: '40px',
                marginTop: '30px',
                marginRight: '15px',
              }}
            >
              {details?.status === '1' ? (
                <Button
                  style={{ dialogButtonStyle, width: '169px', height: '56px' }}
                  sx={{
                    width: '10px',
                    marginLeft: '24px',
                    background: '#F02323',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#F02323',
                      color: 'white',
                    },
                  }}
                  // onClick={() => handleBlock()}
                  disabled={!(dirty && isValid)}
                  variant="contained"
                  type="submit"
                >
                  Yes
                </Button>
              ) : (
                <Button
                  style={{ dialogButtonStyle, width: '169px', height: '56px' }}
                  sx={{
                    width: '10px',
                    marginLeft: '24px',
                    background: 'theme.palette.primary.dark',
                    color: 'white',
                    '&:hover': {
                      background: 'theme.palette.primary.dark',
                      color: 'white',
                    },
                  }}
                  // onClick={() => handleBlock()}
                  disabled={!(dirty && isValid)}
                  variant="contained"
                  type="submit"
                >
                  Yes
                </Button>
              )}

              <Button
                sx={[
                  dialogButtonCancel,
                  {
                    color: theme.palette.primary.main,
                    borderColor: '#14285A33',
                    backgroundColor: '#14285A1A',
                    '&:hover': {
                      // backgroundColor: theme.palette.secondary.main,
                      // color: theme.palette.background.main,
                      // borderColor: theme.palette.secondary.main,
                    },
                  },
                ]}
                style={{ width: '169px', marginLeft: '80px' }}
                variant="outlined"
                onClick={() => {
                  handleClose();
                  //   setConfirmVal('');
                }}
              >
                No
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}
